<template>
	<button
		@click.stop="$emit('click')"
		:class="['app-button', ...classes]"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	props: {
		modifier: String
	},

	computed: {
		classes () {
			if (!this.modifier) {
				return ''
			} else {
				const mod = this.modifier
					.split(' ')
					.reduce((names, name) => names + `app-button--${name} `, '')
				return mod
			}
		}
	}
}
</script>

<style lang='scss' scoped>
.app-button {
	font-size: 1em;
	font-family: inherit;
	border: 1px solid;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: space-around;
	outline: none;

	> * {
		display: inline-block;
		height: 1em;
		line-height: 1em;
	}

	&--large {
		border-radius: 5px;
		min-width: 8em;
		padding: 5px 10px;
	}

	&--small {
		border-radius: 3px;
		min-width: 4em;
		padding: 5px;
	}

	&--large-primary {
		@extend .app-button--large;
		color: #fff;
		background-color: $primary;
		border-color: $primary;
	}

	&--large-secondary {
		@extend .app-button--large;
		color: #fff;
		background-color: $secondary;
		border-color: $secondary;
	}

	&--large-warning {
		@extend .app-button--large;
		color: #fff;
		background-color: $warning;
		border-color: $warning;
	}

	&--large-danger {
		@extend .app-button--large;
		color: #fff;
		background-color: $danger;
		border-color: $danger;
	}

	&--large-primary-ghost {
		@extend .app-button--large;
		color: $primary;
		border-color: $primary;
		background-color: transparent;
	}

	&--small-primary {
		@extend .app-button--small;
		background-color: $primary-light;
		border-color: $primary-light;
		color: $primary;
	}

	&--small-secondary {
		@extend .app-button--small;
		background-color: $secondary-light;
		border-color: $secondary-light;
		color: $secondary;
	}

	&--small-warning {
		@extend .app-button--small;
		background-color: $warning-light;
		border-color: $warning-light;
		color: $warning;
	}

	&--small-danger {
		@extend .app-button--small;
		background-color: $danger-light;
		border-color: $danger-light;
		color: $danger;
	}

	&--icon {
		border-radius: 3px;
		padding: 0;
		min-width: 2em;
		height: 2em;
	}

	&:hover {
		opacity: 0.8;
	}

	&:disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	&:active {
		opacity: 1;
		filter: brightness(98%);
	}
}
</style>
